// IE 2026 10 12 / ODOO-345618 (заказ Игоря: параметры панели после смены ПМ)
// Смена процессной модели без пересборки стола (pmKeepView) не перечитывает запись стола: значения строк параметров
// (doc.params.fieldsMapping[].attr.value / valueStr — их считает бэк в workspace_open под моделью запроса) оставались
// от прежней модели, и раздел «Params» панели ⌄ глобальных чипсов показывал их. Перенос значений свежего ответа в живую
// запись — по binding строки (вложенные строки attrs — так же); прочие свойства строк (use, порядок, правки) не трогаются.
// pmParams-patch v3: изменившиеся attr собираются (out) — стор берёт им названия ссылок тем же путём, что панель (get_valueStr).

const VALUE_KEYS = ['value', 'valueStr']

function indexByBinding(rows, out = new Map()) {
    for (const row of (Array.isArray(rows) ? rows : [])) {
        const b = row && row.attr && row.attr.binding
        if (b && !out.has(b)) out.set(b, row)
        if (row && Array.isArray(row.attrs)) indexByBinding(row.attrs, out)
    }
    return out
}

// перенести значения строк свежего fieldsMapping в живой; вернуть число изменённых строк; out (массив) — сюда кладутся изменившиеся attr
export function pmParams_merge(localRows, freshRows, out = null) {
    const fresh = indexByBinding(freshRows)
    let changed = 0
    const walk = (rows) => {
        for (const row of (Array.isArray(rows) ? rows : [])) {
            const attr = row && row.attr
            const src = attr && attr.binding ? fresh.get(attr.binding) : null
            // значение то же — подпись (valueStr) живой записи остаётся: в ответе workspace_open у ссылок она бывает сырым id,
            // а в живой записи уже название (проба PP1 после наката: Status «statusPlan-draft» вместо «Draft»)
            if (src && src.attr && JSON.stringify(attr.value) !== JSON.stringify(src.attr.value)) {
                for (const k of VALUE_KEYS) attr[k] = src.attr[k]
                if (Array.isArray(out)) out.push(attr)
                changed++
            }
            if (row && Array.isArray(row.attrs)) walk(row.attrs)
        }
    }
    walk(localRows)
    return changed
}

// изменившиеся attr-ссылки, которым нужно название (valueStr из ответа бэка — сырой id)
export function pmParams_linkAttrs(attrs) {
    return (Array.isArray(attrs) ? attrs : []).filter(a => a && a.attr_type === 'AttrLink' && a.relation_segment && a.value !== undefined && a.value !== null && a.value !== '' && typeof a.value !== 'object')
}

// runtime-параметры стола (record.params): ключи свежего ответа замещают прежние, прочие остаются
export function pmParams_runtime(localParams, freshParams) {
    if (!freshParams || typeof freshParams !== 'object') return localParams
    return { ...(localParams && typeof localParams === 'object' ? localParams : {}), ...freshParams }
}
